import ScannedLeads from "./ScannedLeads";

const Attendees = () => {
  return (
    <div className="w-full min-h-[90vh] bg-[#FAFAFA] md:ml-[17%] md:w-[83%] md:bg-white md:min-h-full">
      <div className=" pb-[70px] md:mt-[70px]">
        <ScannedLeads />
      </div>
    </div>
  );
};

export default Attendees;
